import type { Scene } from 'three';

/**
 * Configuration for LightingManager
 */
export type LightingManagerConfig = {
	/** Scene to add lights to */
	scene: Scene;
	/** Enable shadows */
	shadowsEnabled?: boolean;
	/** Shadow map size */
	shadowMapSize?: number;
};

/**
 * Lighting preset configurations
 */
export type LightingPreset = {
	ambient: {
		color: number;
		intensity: number;
	};
	directional: {
		color: number;
		intensity: number;
		position: { x: number; y: number; z: number };
		target: { x: number; y: number; z: number };
	};
	hemisphere: {
		skyColor: number;
		groundColor: number;
		intensity: number;
	};
};

/**
 * Configuration for highlight spotlight
 */
export type HighlightSpotlightConfig = {
	color?: number;
	intensity?: number;
	angle?: number;
	penumbra?: number;
	decay?: number;
	distance?: number;
};

/**
 * Default lighting preset for kitchen scenes
 * Light source positioned at center above kitchen (yellow circle center)
 * Light target at kitchen mid-height (will be updated to red sphere position)
 */
export const DEFAULT_LIGHTING_PRESET: LightingPreset = {
	ambient: {
		color: 0xffffff,
		intensity: 1.0
	},
	directional: {
		color: 0xffffff,
		intensity: 3.0,
		// Default position: center above typical kitchen (highlightCircleY = height + 90)
		position: { x: 0, y: 140, z: 0 },
		// Default target: kitchen center (updated when kitchen data is available)
		target: { x: 0, y: 25, z: 0 }
	},
	hemisphere: {
		skyColor: 0x87ceeb, // Sky blue
		// Neutral light gray (was 0xffe4b5 moccasin). The warm peach ground color
		// tinted every downward-facing facet — most visible on slat finishes
		// whose GLB ridges have many small downward facets, reading as pink.
		groundColor: 0xeaeaea,
		intensity: 0.6
	}
};
